import { Card, Image, MenuItem, TabPane } from 'semantic-ui-react'
import styled from 'styled-components'
import CustomIcon from '~/components/CustomIcon'

export const StyledMenuItem = styled(MenuItem)`
 .error {
  color: red;
 }
`
export const StyledTabPane = styled(TabPane)`
  padding: 0 !important;
  background: none !important;
  border: none !important;
  padding-bottom: 1rem !important;
`

export const StyledCard = styled(Card)`
  &&& {
    width: 350px;
    margin-right: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
    padding: 1em;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const StyledHeader = styled(Card.Header)`
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
  &&& {
    font-size: 16px !important;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
`;

export const StyledMeta = styled(Card.Meta)`
  &&& {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: baseline;

    svg {
      margin-right: 0.5rem;
    }
  }
`;

export const StyledDescription = styled(Card.Description)`
  &&& {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
`;

export const StyledIcon = styled(CustomIcon)`
  &&& {
    font-size: 1.3rem;
    color: #aaa;
    transition: all 0.3s ease;

    &:hover {
      opacity: 0.8 !important;
    }
  }
`;

export const StyledImage = styled(Image)`
  &&& {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
`;

export const PrevievWrapper = styled.div`
margin: 30px;
 img, video {
  max-width: 100%;
  display: block;
  width: 100%;
  max-height: 600px;
  object-fit: contain;
  background: #f6f6f6;
 }
`
export const InformationWrapper = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 15px;
 .label {
  font-weight: bold !important;
 }
 .value {
  color: #6c757d !important;
 }
`